// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from "./client";
import { client } from "./client.gen";
import {
    activateUserResponseTransformer,
    analyzeBlobStorageResponseTransformer,
    confirmLessonResponseTransformer,
    confirmSchoolRequestUpdateResponseTransformer,
    createAnswerResponseTransformer,
    createCollaboratorLinkResponseTransformer,
    createEditionResponseTransformer,
    createLessonResponseTransformer,
    createNotificationResponseTransformer,
    createSchoolRequestResponseTransformer,
    createSchoolResponseTransformer,
    createWasteCollectionFormResponseTransformer,
    editWasteContainerRequestResponseTransformer,
    getAllAnswersResponseTransformer,
    getAllEditionsResponseTransformer,
    getAllLessonsResponseTransformer,
    getAllNotificationsResponseTransformer,
    getAllResponseTransformer,
    getAllSchoolsResponseTransformer,
    getAllWasteCollectionFormsResponseTransformer,
    getAnswerByIdResponseTransformer,
    getAnswersByLessonResponseTransformer,
    getAnswersForSubmissionResponseTransformer,
    getCollabActivityResponseTransformer,
    getCollabInfoResponseTransformer,
    getDefaultAnswerResponseTransformer,
    getDefaultEditionResponseTransformer,
    getDefaultLessonResponseTransformer,
    getDefaultNotificationResponseTransformer,
    getDefaultSchoolRequestResponseTransformer,
    getDefaultSchoolResponseTransformer,
    getDefaultWasteCollectionFormResponseTransformer,
    getEditionByIdResponseTransformer,
    getInboxNotificationsResponseTransformer,
    getIstoricProfesoriResponseTransformer,
    getLessonAnswersReportResponseTransformer,
    getLessonByIdResponseTransformer,
    getLessonProgressByTypeResponseTransformer,
    getLessonsByTypeResponseTransformer,
    getNotificationByIdResponseTransformer,
    getNotificationReceiversStatusResponseTransformer,
    getNotificationsReportResponseTransformer,
    getOutboxNotificationsDeprecatedResponseTransformer,
    getOwnSchoolResponseTransformer,
    getOwnTicketRedemptionsResponseTransformer,
    getOwnWasteContainerRequestsResponseTransformer,
    getParentalApprovalByUserResponseTransformer,
    getSchedulerRunsResponseTransformer,
    getSchoolByIdResponseTransformer,
    getSchoolRequestByIdResponseTransformer,
    getSchoolRequestByUserIdResponseTransformer,
    getSchoolRequestsReportResponseTransformer,
    getSchoolsImportDataResponseTransformer,
    getSchoolsReportResponseTransformer,
    getSchoolsStatusReportResponseTransformer,
    getStudentAnswersByLessonAndUserResponseTransformer,
    getStudentLeaderboardResponseTransformer,
    getTicketRedemptionsResponseTransformer,
    getTicketTiersResponseTransformer,
    getUserProfileResponseTransformer,
    getUsersReportResponseTransformer,
    getUsersWithSchoolRequestsReportResponseTransformer,
    getWasteCollectionFormByIdResponseTransformer,
    getWasteCollectionFormsReportResponseTransformer,
    getWasteContainerRequestsReportCountersResponseTransformer,
    getWasteContainerRequestsReportResponseTransformer,
    listCollaboratorLinksResponseTransformer,
    markOwnSchoolRequestVideoSeenResponseTransformer,
    markWasteContainerRequestDeliveredResponseTransformer,
    markWasteContainerRequestProcessedResponseTransformer,
    processWasteCollectionFormResponseTransformer,
    reassignSchoolRequestToProfessorResponseTransformer,
    redeemTicketResponseTransformer,
    setCurrentEditionResponseTransformer,
    updateAnswerResponseTransformer,
    updateEditionResponseTransformer,
    updateLessonResponseTransformer,
    updateNotificationResponseTransformer,
    updateParticipantsResponseTransformer,
    updateSchoolRequestApprovalStatusResponseTransformer,
    updateSchoolRequestByAdminResponseTransformer,
    updateSchoolRequestResponseTransformer,
    updateSchoolResponseTransformer,
    updateTicketRedemptionStatusResponseTransformer,
    updateUserActivationResponseTransformer,
    updateUserByAdminResponseTransformer,
    updateUserProfileResponseTransformer,
    updateUserSignatureResponseTransformer,
    updateWasteCollectionFormByAdminResponseTransformer,
    updateWasteCollectionFormRealValuesResponseTransformer,
    updateWasteCollectionFormResponseTransformer,
    validateWasteCollectionFormResponseTransformer,
} from "./transformers.gen";
import type {
    ActivateUserData,
    ActivateUserErrors,
    ActivateUserResponses,
    AnalyzeBlobStorageData,
    AnalyzeBlobStorageErrors,
    AnalyzeBlobStorageResponses,
    AuthenticateData,
    AuthenticateErrors,
    AuthenticateResponses,
    ChangePasswordData,
    ChangePasswordErrors,
    ChangePasswordResponses,
    ConfirmaCodScoalaData,
    ConfirmaCodScoalaErrors,
    ConfirmaCodScoalaResponses,
    ConfirmLessonData,
    ConfirmLessonErrors,
    ConfirmLessonResponses,
    ConfirmSchoolRequestUpdateData,
    ConfirmSchoolRequestUpdateErrors,
    ConfirmSchoolRequestUpdateResponses,
    CreateAnswerData,
    CreateAnswerErrors,
    CreateAnswerResponses,
    CreateCollaboratorLinkData,
    CreateCollaboratorLinkErrors,
    CreateCollaboratorLinkResponses,
    CreateCompanyData,
    CreateCompanyErrors,
    CreateCompanyResponses,
    CreateEditionData,
    CreateEditionErrors,
    CreateEditionResponses,
    CreateFaqEntryData,
    CreateFaqEntryErrors,
    CreateFaqEntryResponses,
    CreateLessonData,
    CreateLessonErrors,
    CreateLessonResponses,
    CreateNotificationData,
    CreateNotificationErrors,
    CreateNotificationResponses,
    CreateOptionData,
    CreateOptionErrors,
    CreateOptionResponses,
    CreateSchoolData,
    CreateSchoolErrors,
    CreateSchoolRequestData,
    CreateSchoolRequestErrors,
    CreateSchoolRequestResponses,
    CreateSchoolResponses,
    CreateSlideData,
    CreateSlideErrors,
    CreateSlideResponses,
    CreateTicketTierData,
    CreateTicketTierErrors,
    CreateTicketTierResponses,
    CreateWasteCollectionFormData,
    CreateWasteCollectionFormErrors,
    CreateWasteCollectionFormResponses,
    CreateWasteContainerRequestData,
    CreateWasteContainerRequestErrors,
    CreateWasteContainerRequestResponses,
    DeleteAnswerData,
    DeleteAnswerErrors,
    DeleteAnswerResponses,
    DeleteCompanyData,
    DeleteCompanyErrors,
    DeleteCompanyResponses,
    DeleteEditionData,
    DeleteEditionErrors,
    DeleteEditionResponses,
    DeleteFaqEntryData,
    DeleteFaqEntryErrors,
    DeleteFaqEntryResponses,
    DeleteFileData,
    DeleteFileErrors,
    DeleteFileResponses,
    DeleteLessonAnswersByUserLessonAndEditionData,
    DeleteLessonAnswersByUserLessonAndEditionErrors,
    DeleteLessonAnswersByUserLessonAndEditionResponses,
    DeleteLessonData,
    DeleteLessonErrors,
    DeleteLessonResponses,
    DeleteNotificationData,
    DeleteNotificationErrors,
    DeleteNotificationResponses,
    DeleteOptionData,
    DeleteOptionErrors,
    DeleteOptionResponses,
    DeleteSchoolData,
    DeleteSchoolErrors,
    DeleteSchoolRequestData,
    DeleteSchoolRequestErrors,
    DeleteSchoolRequestResponses,
    DeleteSchoolResponses,
    DeleteSlideData,
    DeleteSlideErrors,
    DeleteSlideResponses,
    DeleteTicketTierData,
    DeleteTicketTierErrors,
    DeleteTicketTierResponses,
    DeleteWasteCollectionFormData,
    DeleteWasteCollectionFormErrors,
    DeleteWasteCollectionFormResponses,
    DepuneActivitatePracticaData,
    DepuneActivitatePracticaErrors,
    DepuneActivitatePracticaResponses,
    DescarcaExercitiiPdfColabData,
    DescarcaExercitiiPdfColabErrors,
    DescarcaExercitiiPdfColabResponses,
    DescarcaExercitiiPdfData,
    DescarcaExercitiiPdfErrors,
    DescarcaExercitiiPdfResponses,
    DescarcaRaspunsuriPdfColabData,
    DescarcaRaspunsuriPdfColabErrors,
    DescarcaRaspunsuriPdfColabResponses,
    DescarcaRaspunsuriPdfData,
    DescarcaRaspunsuriPdfErrors,
    DescarcaRaspunsuriPdfResponses,
    DeschideSesiuneCodScoalaData,
    DeschideSesiuneCodScoalaErrors,
    DeschideSesiuneCodScoalaResponses,
    DownloadOwnProtocolDeColaborareData,
    DownloadOwnProtocolDeColaborareErrors,
    DownloadOwnProtocolDeColaborareResponses,
    DownloadProtocolDeColaborareData,
    DownloadProtocolDeColaborareErrors,
    DownloadProtocolDeColaborareResponses,
    EditWasteContainerRequestData,
    EditWasteContainerRequestErrors,
    EditWasteContainerRequestResponses,
    ExchangeData,
    ExchangeErrors,
    ExchangeResponses,
    ExportReportData,
    ExportReportErrors,
    ExportReportResponses,
    ForgotPasswordData,
    ForgotPasswordErrors,
    ForgotPasswordResponses,
    GetAllAnswersData,
    GetAllAnswersErrors,
    GetAllAnswersResponses,
    GetAllCompaniesData,
    GetAllCompaniesErrors,
    GetAllCompaniesResponses,
    GetAllData,
    GetAllEditionsData,
    GetAllEditionsErrors,
    GetAllEditionsResponses,
    GetAllErrors,
    GetAllFaqEntriesData,
    GetAllFaqEntriesErrors,
    GetAllFaqEntriesResponses,
    GetAllFoldersData,
    GetAllFoldersErrors,
    GetAllFoldersResponses,
    GetAllLessonsData,
    GetAllLessonsErrors,
    GetAllLessonsResponses,
    GetAllNotificationsData,
    GetAllNotificationsErrors,
    GetAllNotificationsResponses,
    GetAllOptionsData,
    GetAllOptionsErrors,
    GetAllOptionsResponses,
    GetAllResponses,
    GetAllSchoolsData,
    GetAllSchoolsErrors,
    GetAllSchoolsResponses,
    GetAllSlidesData,
    GetAllSlidesErrors,
    GetAllSlidesResponses,
    GetAllWasteCollectionFormsData,
    GetAllWasteCollectionFormsErrors,
    GetAllWasteCollectionFormsResponses,
    GetAnswerByIdData,
    GetAnswerByIdErrors,
    GetAnswerByIdResponses,
    GetAnswersByLessonData,
    GetAnswersByLessonErrors,
    GetAnswersByLessonResponses,
    GetAnswersForSubmissionData,
    GetAnswersForSubmissionErrors,
    GetAnswersForSubmissionResponses,
    GetByIdData,
    GetByIdErrors,
    GetByIdResponses,
    GetCollabActivityData,
    GetCollabActivityErrors,
    GetCollabActivityResponses,
    GetCollabInfoData,
    GetCollabInfoErrors,
    GetCollabInfoResponses,
    GetCompanyByIdData,
    GetCompanyByIdErrors,
    GetCompanyByIdResponses,
    GetContactsData,
    GetContactsErrors,
    GetContactsResponses,
    GetCountiesListData,
    GetCountiesListErrors,
    GetCountiesListResponses,
    GetDefaultAnswerData,
    GetDefaultAnswerErrors,
    GetDefaultAnswerResponses,
    GetDefaultCompanyData,
    GetDefaultCompanyErrors,
    GetDefaultCompanyResponses,
    GetDefaultData,
    GetDefaultEditionData,
    GetDefaultEditionErrors,
    GetDefaultEditionResponses,
    GetDefaultErrors,
    GetDefaultLessonData,
    GetDefaultLessonErrors,
    GetDefaultLessonResponses,
    GetDefaultNotificationData,
    GetDefaultNotificationErrors,
    GetDefaultNotificationResponses,
    GetDefaultOptionData,
    GetDefaultOptionErrors,
    GetDefaultOptionResponses,
    GetDefaultResponses,
    GetDefaultSchoolData,
    GetDefaultSchoolErrors,
    GetDefaultSchoolRequestData,
    GetDefaultSchoolRequestErrors,
    GetDefaultSchoolRequestResponses,
    GetDefaultSchoolResponses,
    GetDefaultSlideData,
    GetDefaultSlideErrors,
    GetDefaultSlideResponses,
    GetDefaultWasteCollectionFormData,
    GetDefaultWasteCollectionFormErrors,
    GetDefaultWasteCollectionFormResponses,
    GetEditionByIdData,
    GetEditionByIdErrors,
    GetEditionByIdResponses,
    GetEditionDocumentsData,
    GetEditionDocumentsErrors,
    GetEditionDocumentsResponses,
    GetInboxNotificationsData,
    GetInboxNotificationsErrors,
    GetInboxNotificationsResponses,
    GetIstoricProfesoriData,
    GetIstoricProfesoriErrors,
    GetIstoricProfesoriResponses,
    GetLessonAnswersReportData,
    GetLessonAnswersReportErrors,
    GetLessonAnswersReportResponses,
    GetLessonByIdData,
    GetLessonByIdErrors,
    GetLessonByIdResponses,
    GetLessonProgressByTypeData,
    GetLessonProgressByTypeErrors,
    GetLessonProgressByTypeResponses,
    GetLessonsByTypeData,
    GetLessonsByTypeErrors,
    GetLessonsByTypeResponses,
    GetNotificationByIdData,
    GetNotificationByIdErrors,
    GetNotificationByIdResponses,
    GetNotificationReceiversStatusData,
    GetNotificationReceiversStatusErrors,
    GetNotificationReceiversStatusResponses,
    GetNotificationsReportData,
    GetNotificationsReportErrors,
    GetNotificationsReportResponses,
    GetOnboardingVideoData,
    GetOnboardingVideoErrors,
    GetOnboardingVideoResponses,
    GetOptionByIdData,
    GetOptionByIdErrors,
    GetOptionByIdResponses,
    GetOutboxNotificationsDeprecatedData,
    GetOutboxNotificationsDeprecatedErrors,
    GetOutboxNotificationsDeprecatedResponses,
    GetOwnSchoolData,
    GetOwnSchoolErrors,
    GetOwnSchoolPointsBalanceData,
    GetOwnSchoolPointsBalanceErrors,
    GetOwnSchoolPointsBalanceResponses,
    GetOwnSchoolRequestData,
    GetOwnSchoolRequestErrors,
    GetOwnSchoolRequestResponses,
    GetOwnSchoolResponses,
    GetOwnTicketRedemptionsData,
    GetOwnTicketRedemptionsErrors,
    GetOwnTicketRedemptionsResponses,
    GetOwnWasteContainerRequestsData,
    GetOwnWasteContainerRequestsErrors,
    GetOwnWasteContainerRequestsResponses,
    GetParentalApprovalByUserData,
    GetParentalApprovalByUserErrors,
    GetParentalApprovalByUserResponses,
    GetSchedulerRunsData,
    GetSchedulerRunsErrors,
    GetSchedulerRunsResponses,
    GetSchoolByIdData,
    GetSchoolByIdErrors,
    GetSchoolByIdResponses,
    GetSchoolClassesData,
    GetSchoolClassesErrors,
    GetSchoolClassesResponses,
    GetSchoolPointsBalanceData,
    GetSchoolPointsBalanceErrors,
    GetSchoolPointsBalanceResponses,
    GetSchoolRegistrationStatusData,
    GetSchoolRegistrationStatusErrors,
    GetSchoolRegistrationStatusResponses,
    GetSchoolRequestByIdData,
    GetSchoolRequestByIdErrors,
    GetSchoolRequestByIdResponses,
    GetSchoolRequestByUserIdData,
    GetSchoolRequestByUserIdErrors,
    GetSchoolRequestByUserIdResponses,
    GetSchoolRequestsReportData,
    GetSchoolRequestsReportErrors,
    GetSchoolRequestsReportResponses,
    GetSchoolsDropdownData,
    GetSchoolsDropdownErrors,
    GetSchoolsDropdownResponses,
    GetSchoolsImportDataData,
    GetSchoolsImportDataErrors,
    GetSchoolsImportDataResponses,
    GetSchoolsReportData,
    GetSchoolsReportErrors,
    GetSchoolsReportResponses,
    GetSchoolsStatusReportData,
    GetSchoolsStatusReportErrors,
    GetSchoolsStatusReportResponses,
    GetSlideByIdData,
    GetSlideByIdErrors,
    GetSlideByIdResponses,
    GetStudentAnswersByLessonAndUserData,
    GetStudentAnswersByLessonAndUserErrors,
    GetStudentAnswersByLessonAndUserResponses,
    GetStudentLeaderboardData,
    GetStudentLeaderboardErrors,
    GetStudentLeaderboardResponses,
    GetTicketRedemptionsData,
    GetTicketRedemptionsErrors,
    GetTicketRedemptionsResponses,
    GetTicketTiersData,
    GetTicketTiersErrors,
    GetTicketTiersResponses,
    GetUserProfileData,
    GetUserProfileErrors,
    GetUserProfileResponses,
    GetUsersReportData,
    GetUsersReportErrors,
    GetUsersReportResponses,
    GetUsersWithSchoolRequestsReportData,
    GetUsersWithSchoolRequestsReportErrors,
    GetUsersWithSchoolRequestsReportResponses,
    GetWasteCollectionFormByIdData,
    GetWasteCollectionFormByIdErrors,
    GetWasteCollectionFormByIdResponses,
    GetWasteCollectionFormsReportData,
    GetWasteCollectionFormsReportErrors,
    GetWasteCollectionFormsReportResponses,
    GetWasteContainerRequestsReportCountersData,
    GetWasteContainerRequestsReportCountersErrors,
    GetWasteContainerRequestsReportCountersResponses,
    GetWasteContainerRequestsReportData,
    GetWasteContainerRequestsReportErrors,
    GetWasteContainerRequestsReportResponses,
    HideLessonData,
    HideLessonErrors,
    HideLessonResponses,
    ImportMecSchoolListData,
    ImportMecSchoolListErrors,
    ImportMecSchoolListResponses,
    InregistreazaAcordCookieData,
    InregistreazaAcordCookieErrors,
    InregistreazaAcordCookieResponses,
    ListCollaboratorLinksData,
    ListCollaboratorLinksErrors,
    ListCollaboratorLinksResponses,
    LogoutData,
    LogoutErrors,
    LogoutResponses,
    MarkNotificationAsReadData,
    MarkNotificationAsReadErrors,
    MarkNotificationAsReadResponses,
    MarkOwnSchoolRequestVideoSeenData,
    MarkOwnSchoolRequestVideoSeenErrors,
    MarkOwnSchoolRequestVideoSeenResponses,
    MarkWasteContainerRequestDeliveredData,
    MarkWasteContainerRequestDeliveredErrors,
    MarkWasteContainerRequestDeliveredResponses,
    MarkWasteContainerRequestProcessedData,
    MarkWasteContainerRequestProcessedErrors,
    MarkWasteContainerRequestProcessedResponses,
    OtpInregistrareData,
    OtpInregistrareErrors,
    OtpInregistrareResponses,
    OtpInscriereData,
    OtpInscriereErrors,
    OtpInscriereResponses,
    ProcessWasteCollectionFormData,
    ProcessWasteCollectionFormErrors,
    ProcessWasteCollectionFormResponses,
    ReassignSchoolRequestToProfessorData,
    ReassignSchoolRequestToProfessorErrors,
    ReassignSchoolRequestToProfessorResponses,
    RedeemTicketData,
    RedeemTicketErrors,
    RedeemTicketResponses,
    ReenrollData,
    ReenrollErrors,
    ReenrollResponses,
    RefreshTokenData,
    RefreshTokenErrors,
    RefreshTokenResponses,
    RegisterData,
    RegisterErrors,
    RegisterResponses,
    RequestData,
    RequestErrors,
    RequestResponses,
    ResendNotificationData,
    ResendNotificationErrors,
    ResendNotificationResponses,
    ResetPasswordData,
    ResetPasswordErrors,
    ResetPasswordResponses,
    ResyncSchoolToErpData,
    ResyncSchoolToErpErrors,
    ResyncSchoolToErpResponses,
    RevokeCollaboratorLinkData,
    RevokeCollaboratorLinkErrors,
    RevokeCollaboratorLinkResponses,
    RootData,
    RootErrors,
    RootResponses,
    SendErrorMessageData,
    SendErrorMessageErrors,
    SendErrorMessageResponses,
    SetCurrentEditionData,
    SetCurrentEditionErrors,
    SetCurrentEditionResponses,
    SetPhoneCallNoteData,
    SetPhoneCallNoteErrors,
    SetPhoneCallNoteResponses,
    SubmitCollabActivityData,
    SubmitCollabActivityErrors,
    SubmitCollabActivityResponses,
    UpdateAnswerData,
    UpdateAnswerErrors,
    UpdateAnswerResponses,
    UpdateCompanyData,
    UpdateCompanyErrors,
    UpdateCompanyResponses,
    UpdateEditionData,
    UpdateEditionErrors,
    UpdateEditionResponses,
    UpdateFaqEntryData,
    UpdateFaqEntryErrors,
    UpdateFaqEntryResponses,
    UpdateLessonData,
    UpdateLessonErrors,
    UpdateLessonResponses,
    UpdateNotificationData,
    UpdateNotificationErrors,
    UpdateNotificationResponses,
    UpdateOptionData,
    UpdateOptionErrors,
    UpdateOptionResponses,
    UpdateParticipantsData,
    UpdateParticipantsErrors,
    UpdateParticipantsResponses,
    UpdateSchoolData,
    UpdateSchoolErrors,
    UpdateSchoolRequestApprovalStatusData,
    UpdateSchoolRequestApprovalStatusErrors,
    UpdateSchoolRequestApprovalStatusResponses,
    UpdateSchoolRequestByAdminData,
    UpdateSchoolRequestByAdminErrors,
    UpdateSchoolRequestByAdminResponses,
    UpdateSchoolRequestData,
    UpdateSchoolRequestErrors,
    UpdateSchoolRequestResponses,
    UpdateSchoolResponses,
    UpdateSlideData,
    UpdateSlideErrors,
    UpdateSlideResponses,
    UpdateTicketRedemptionStatusData,
    UpdateTicketRedemptionStatusErrors,
    UpdateTicketRedemptionStatusResponses,
    UpdateTicketTierData,
    UpdateTicketTierErrors,
    UpdateTicketTierResponses,
    UpdateUserActivationData,
    UpdateUserActivationErrors,
    UpdateUserActivationResponses,
    UpdateUserByAdminData,
    UpdateUserByAdminErrors,
    UpdateUserByAdminResponses,
    UpdateUserProfileData,
    UpdateUserProfileErrors,
    UpdateUserProfileResponses,
    UpdateUserSignatureData,
    UpdateUserSignatureErrors,
    UpdateUserSignatureResponses,
    UpdateWasteCollectionFormByAdminData,
    UpdateWasteCollectionFormByAdminErrors,
    UpdateWasteCollectionFormByAdminResponses,
    UpdateWasteCollectionFormData,
    UpdateWasteCollectionFormErrors,
    UpdateWasteCollectionFormRealValuesData,
    UpdateWasteCollectionFormRealValuesErrors,
    UpdateWasteCollectionFormRealValuesResponses,
    UpdateWasteCollectionFormResponses,
    UploadCollabPhotoData,
    UploadCollabPhotoErrors,
    UploadCollabPhotoResponses,
    UploadImageData,
    UploadImageErrors,
    UploadImageResponses,
    ValidateWasteCollectionFormData,
    ValidateWasteCollectionFormErrors,
    ValidateWasteCollectionFormResponses,
    VerifyData,
    VerifyErrors,
    VerifyResponses,
} from "./types.gen";

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
    TData,
    ThrowOnError
> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Confirm school form update for new year registration
 */
export const confirmSchoolRequestUpdate = <ThrowOnError extends boolean = false>(
    options: Options<ConfirmSchoolRequestUpdateData, ThrowOnError>,
) => {
    return (options.client ?? client).put<
        ConfirmSchoolRequestUpdateResponses,
        ConfirmSchoolRequestUpdateErrors,
        ThrowOnError
    >({
        responseTransformer: confirmSchoolRequestUpdateResponseTransformer,
        url: "/api/school-requests/confirmation",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Profesorul solicita recipiente pentru scoala lui
 */
export const createWasteContainerRequest = <ThrowOnError extends boolean = false>(
    options: Options<CreateWasteContainerRequestData, ThrowOnError>,
) => {
    return (options.client ?? client).post<
        CreateWasteContainerRequestResponses,
        CreateWasteContainerRequestErrors,
        ThrowOnError
    >({
        url: "/api/waste-container-requests",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Get all waste collection forms
 */
export const getAllWasteCollectionForms = <ThrowOnError extends boolean = false>(
    options?: Options<GetAllWasteCollectionFormsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        GetAllWasteCollectionFormsResponses,
        GetAllWasteCollectionFormsErrors,
        ThrowOnError
    >({
        responseTransformer: getAllWasteCollectionFormsResponseTransformer,
        url: "/api/waste-collection-forms",
        ...options,
    });
};

/**
 * Update an existing waste collection form
 */
export const updateWasteCollectionForm = <ThrowOnError extends boolean = false>(
    options: Options<UpdateWasteCollectionFormData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        UpdateWasteCollectionFormResponses,
        UpdateWasteCollectionFormErrors,
        ThrowOnError
    >({
        responseTransformer: updateWasteCollectionFormResponseTransformer,
        url: "/api/waste-collection-forms",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Create a new waste collection form
 */
export const createWasteCollectionForm = <ThrowOnError extends boolean = false>(
    options: Options<CreateWasteCollectionFormData, ThrowOnError>,
) => {
    return (options.client ?? client).post<
        CreateWasteCollectionFormResponses,
        CreateWasteCollectionFormErrors,
        ThrowOnError
    >({
        responseTransformer: createWasteCollectionFormResponseTransformer,
        url: "/api/waste-collection-forms",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Nivelurile unei editii (implicit editia curenta)
 */
export const getTicketTiers = <ThrowOnError extends boolean = false>(
    options?: Options<GetTicketTiersData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetTicketTiersResponses, GetTicketTiersErrors, ThrowOnError>({
        responseTransformer: getTicketTiersResponseTransformer,
        url: "/api/ticket-tiers",
        ...options,
    });
};

/**
 * Actualizeaza un nivel
 */
export const updateTicketTier = <ThrowOnError extends boolean = false>(
    options: Options<UpdateTicketTierData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateTicketTierResponses, UpdateTicketTierErrors, ThrowOnError>({
        url: "/api/ticket-tiers",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Creeaza un nivel
 */
export const createTicketTier = <ThrowOnError extends boolean = false>(
    options: Options<CreateTicketTierData, ThrowOnError>,
) => {
    return (options.client ?? client).post<CreateTicketTierResponses, CreateTicketTierErrors, ThrowOnError>({
        url: "/api/ticket-tiers",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Toate rascumpararile unei editii, paginat (admin)
 */
export const getTicketRedemptions = <ThrowOnError extends boolean = false>(
    options: Options<GetTicketRedemptionsData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetTicketRedemptionsResponses, GetTicketRedemptionsErrors, ThrowOnError>({
        responseTransformer: getTicketRedemptionsResponseTransformer,
        url: "/api/ticket-redemptions",
        ...options,
    });
};

/**
 * Coordonatorul rascumpara un tichet pentru scoala lui
 */
export const redeemTicket = <ThrowOnError extends boolean = false>(
    options: Options<RedeemTicketData, ThrowOnError>,
) => {
    return (options.client ?? client).post<RedeemTicketResponses, RedeemTicketErrors, ThrowOnError>({
        responseTransformer: redeemTicketResponseTransformer,
        url: "/api/ticket-redemptions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Get all slides
 */
export const getAllSlides = <ThrowOnError extends boolean = false>(
    options?: Options<GetAllSlidesData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetAllSlidesResponses, GetAllSlidesErrors, ThrowOnError>({
        url: "/api/slides",
        ...options,
    });
};

/**
 * Update an existing slide
 */
export const updateSlide = <ThrowOnError extends boolean = false>(options: Options<UpdateSlideData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateSlideResponses, UpdateSlideErrors, ThrowOnError>({
        url: "/api/slides",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Create a new slide
 */
export const createSlide = <ThrowOnError extends boolean = false>(options: Options<CreateSlideData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateSlideResponses, CreateSlideErrors, ThrowOnError>({
        url: "/api/slides",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Get all schools
 */
export const getAllSchools = <ThrowOnError extends boolean = false>(
    options?: Options<GetAllSchoolsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetAllSchoolsResponses, GetAllSchoolsErrors, ThrowOnError>({
        responseTransformer: getAllSchoolsResponseTransformer,
        url: "/api/schools",
        ...options,
    });
};

/**
 * Update an existing school
 */
export const updateSchool = <ThrowOnError extends boolean = false>(
    options: Options<UpdateSchoolData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateSchoolResponses, UpdateSchoolErrors, ThrowOnError>({
        responseTransformer: updateSchoolResponseTransformer,
        url: "/api/schools",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Create a new school
 */
export const createSchool = <ThrowOnError extends boolean = false>(
    options: Options<CreateSchoolData, ThrowOnError>,
) => {
    return (options.client ?? client).post<CreateSchoolResponses, CreateSchoolErrors, ThrowOnError>({
        responseTransformer: createSchoolResponseTransformer,
        url: "/api/schools",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Linkurile de colaborator ale scolii
 */
export const listCollaboratorLinks = <ThrowOnError extends boolean = false>(
    options: Options<ListCollaboratorLinksData, ThrowOnError>,
) => {
    return (options.client ?? client).get<ListCollaboratorLinksResponses, ListCollaboratorLinksErrors, ThrowOnError>({
        responseTransformer: listCollaboratorLinksResponseTransformer,
        url: "/api/schools/{schoolId}/collaborator-links",
        ...options,
    });
};

/**
 * Creeaza un link de colaborator
 */
export const createCollaboratorLink = <ThrowOnError extends boolean = false>(
    options: Options<CreateCollaboratorLinkData, ThrowOnError>,
) => {
    return (options.client ?? client).post<CreateCollaboratorLinkResponses, CreateCollaboratorLinkErrors, ThrowOnError>(
        {
            responseTransformer: createCollaboratorLinkResponseTransformer,
            url: "/api/schools/{schoolId}/collaborator-links",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        },
    );
};

/**
 * Import the ministry (MEC) school list into school_data_imports
 *
 * Idempotent on `codSiiirUnitate`. Never deletes: units present in the platform but absent from the imported selection are reported, not touched. Returns the three categories from the client requirement.
 */
export const importMecSchoolList = <ThrowOnError extends boolean = false>(
    options?: Options<ImportMecSchoolListData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<ImportMecSchoolListResponses, ImportMecSchoolListErrors, ThrowOnError>({
        ...formDataBodySerializer,
        url: "/api/schools/import-data/mec",
        ...options,
        headers: {
            "Content-Type": null,
            ...options?.headers,
        },
    });
};

export const getAll = <ThrowOnError extends boolean = false>(options?: Options<GetAllData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllResponses, GetAllErrors, ThrowOnError>({
        responseTransformer: getAllResponseTransformer,
        url: "/api/school-requests",
        ...options,
    });
};

/**
 * Update an existing school request
 */
export const updateSchoolRequest = <ThrowOnError extends boolean = false>(
    options: Options<UpdateSchoolRequestData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateSchoolRequestResponses, UpdateSchoolRequestErrors, ThrowOnError>({
        responseTransformer: updateSchoolRequestResponseTransformer,
        url: "/api/school-requests",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Create a new school request
 */
export const createSchoolRequest = <ThrowOnError extends boolean = false>(
    options: Options<CreateSchoolRequestData, ThrowOnError>,
) => {
    return (options.client ?? client).post<CreateSchoolRequestResponses, CreateSchoolRequestErrors, ThrowOnError>({
        responseTransformer: createSchoolRequestResponseTransformer,
        url: "/api/school-requests",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Get all options
 */
export const getAllOptions = <ThrowOnError extends boolean = false>(
    options?: Options<GetAllOptionsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetAllOptionsResponses, GetAllOptionsErrors, ThrowOnError>({
        url: "/api/options",
        ...options,
    });
};

/**
 * Update an existing option
 */
export const updateOption = <ThrowOnError extends boolean = false>(
    options: Options<UpdateOptionData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateOptionResponses, UpdateOptionErrors, ThrowOnError>({
        url: "/api/options",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Create a new option
 */
export const createOption = <ThrowOnError extends boolean = false>(
    options: Options<CreateOptionData, ThrowOnError>,
) => {
    return (options.client ?? client).post<CreateOptionResponses, CreateOptionErrors, ThrowOnError>({
        url: "/api/options",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Get all notifications
 */
export const getAllNotifications = <ThrowOnError extends boolean = false>(
    options?: Options<GetAllNotificationsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetAllNotificationsResponses, GetAllNotificationsErrors, ThrowOnError>({
        responseTransformer: getAllNotificationsResponseTransformer,
        url: "/api/notifications",
        ...options,
    });
};

/**
 * Update an existing notification
 */
export const updateNotification = <ThrowOnError extends boolean = false>(
    options: Options<UpdateNotificationData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateNotificationResponses, UpdateNotificationErrors, ThrowOnError>({
        responseTransformer: updateNotificationResponseTransformer,
        url: "/api/notifications",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Create a new notification
 */
export const createNotification = <ThrowOnError extends boolean = false>(
    options: Options<CreateNotificationData, ThrowOnError>,
) => {
    return (options.client ?? client).post<CreateNotificationResponses, CreateNotificationErrors, ThrowOnError>({
        responseTransformer: createNotificationResponseTransformer,
        url: "/api/notifications",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Resend notification to unread receivers
 */
export const resendNotification = <ThrowOnError extends boolean = false>(
    options: Options<ResendNotificationData, ThrowOnError>,
) => {
    return (options.client ?? client).post<ResendNotificationResponses, ResendNotificationErrors, ThrowOnError>({
        url: "/api/notifications/{id}/resend",
        ...options,
    });
};

/**
 * Get all lessons
 */
export const getAllLessons = <ThrowOnError extends boolean = false>(
    options?: Options<GetAllLessonsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetAllLessonsResponses, GetAllLessonsErrors, ThrowOnError>({
        responseTransformer: getAllLessonsResponseTransformer,
        url: "/api/lessons",
        ...options,
    });
};

/**
 * Update an existing lesson
 */
export const updateLesson = <ThrowOnError extends boolean = false>(
    options: Options<UpdateLessonData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateLessonResponses, UpdateLessonErrors, ThrowOnError>({
        responseTransformer: updateLessonResponseTransformer,
        url: "/api/lessons",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Create a new lesson
 */
export const createLesson = <ThrowOnError extends boolean = false>(
    options: Options<CreateLessonData, ThrowOnError>,
) => {
    return (options.client ?? client).post<CreateLessonResponses, CreateLessonErrors, ThrowOnError>({
        responseTransformer: createLessonResponseTransformer,
        url: "/api/lessons",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Profesorul depune dovada unei activitati practice (poze + clase), direct spre aprobare
 */
export const depuneActivitatePractica = <ThrowOnError extends boolean = false>(
    options: Options<DepuneActivitatePracticaData, ThrowOnError>,
) => {
    return (options.client ?? client).post<
        DepuneActivitatePracticaResponses,
        DepuneActivitatePracticaErrors,
        ThrowOnError
    >({
        url: "/api/lessons/{id}/depunere-activitate",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const uploadImage = <ThrowOnError extends boolean = false>(options?: Options<UploadImageData, ThrowOnError>) => {
    return (options?.client ?? client).post<UploadImageResponses, UploadImageErrors, ThrowOnError>({
        url: "/api/files/upload",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get all FAQ entries
 */
export const getAllFaqEntries = <ThrowOnError extends boolean = false>(
    options?: Options<GetAllFaqEntriesData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetAllFaqEntriesResponses, GetAllFaqEntriesErrors, ThrowOnError>({
        url: "/api/faq",
        ...options,
    });
};

/**
 * Update an existing FAQ entry (full replace: send all fields)
 */
export const updateFaqEntry = <ThrowOnError extends boolean = false>(
    options: Options<UpdateFaqEntryData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateFaqEntryResponses, UpdateFaqEntryErrors, ThrowOnError>({
        url: "/api/faq",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Create a new FAQ entry
 */
export const createFaqEntry = <ThrowOnError extends boolean = false>(
    options: Options<CreateFaqEntryData, ThrowOnError>,
) => {
    return (options.client ?? client).post<CreateFaqEntryResponses, CreateFaqEntryErrors, ThrowOnError>({
        url: "/api/faq",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Trimite din nou o scoala in ERP, sincron, si intoarce raspunsul ERP-ului
 */
export const resyncSchoolToErp = <ThrowOnError extends boolean = false>(
    options: Options<ResyncSchoolToErpData, ThrowOnError>,
) => {
    return (options.client ?? client).post<ResyncSchoolToErpResponses, ResyncSchoolToErpErrors, ThrowOnError>({
        url: "/api/erp/schools/{schoolId}/resync",
        ...options,
    });
};

/**
 * Get all editions
 */
export const getAllEditions = <ThrowOnError extends boolean = false>(
    options?: Options<GetAllEditionsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetAllEditionsResponses, GetAllEditionsErrors, ThrowOnError>({
        responseTransformer: getAllEditionsResponseTransformer,
        url: "/api/editions",
        ...options,
    });
};

/**
 * Update an existing edition
 */
export const updateEdition = <ThrowOnError extends boolean = false>(
    options: Options<UpdateEditionData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateEditionResponses, UpdateEditionErrors, ThrowOnError>({
        responseTransformer: updateEditionResponseTransformer,
        url: "/api/editions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Create a new edition
 */
export const createEdition = <ThrowOnError extends boolean = false>(
    options: Options<CreateEditionData, ThrowOnError>,
) => {
    return (options.client ?? client).post<CreateEditionResponses, CreateEditionErrors, ThrowOnError>({
        responseTransformer: createEditionResponseTransformer,
        url: "/api/editions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Marcheaza editia ca fiind cea curenta si declanseaza reconfirmarea profesorilor (DBEST)
 */
export const setCurrentEdition = <ThrowOnError extends boolean = false>(
    options: Options<SetCurrentEditionData, ThrowOnError>,
) => {
    return (options.client ?? client).post<SetCurrentEditionResponses, SetCurrentEditionErrors, ThrowOnError>({
        responseTransformer: setCurrentEditionResponseTransformer,
        url: "/api/editions/{id}/set-current",
        ...options,
    });
};

export const sendErrorMessage = <ThrowOnError extends boolean = false>(
    options: Options<SendErrorMessageData, ThrowOnError>,
) => {
    return (options.client ?? client).post<SendErrorMessageResponses, SendErrorMessageErrors, ThrowOnError>({
        url: "/api/discord-messages",
        ...options,
    });
};

/**
 * Salveaza alegerea facuta in bannerul de cookie-uri
 */
export const inregistreazaAcordCookie = <ThrowOnError extends boolean = false>(
    options: Options<InregistreazaAcordCookieData, ThrowOnError>,
) => {
    return (options.client ?? client).post<
        InregistreazaAcordCookieResponses,
        InregistreazaAcordCookieErrors,
        ThrowOnError
    >({
        url: "/api/cookie-consents",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Get all companies
 */
export const getAllCompanies = <ThrowOnError extends boolean = false>(
    options?: Options<GetAllCompaniesData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetAllCompaniesResponses, GetAllCompaniesErrors, ThrowOnError>({
        url: "/api/companies",
        ...options,
    });
};

/**
 * Update an existing company
 */
export const updateCompany = <ThrowOnError extends boolean = false>(
    options: Options<UpdateCompanyData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateCompanyResponses, UpdateCompanyErrors, ThrowOnError>({
        url: "/api/companies",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Create a new company
 */
export const createCompany = <ThrowOnError extends boolean = false>(
    options: Options<CreateCompanyData, ThrowOnError>,
) => {
    return (options.client ?? client).post<CreateCompanyResponses, CreateCompanyErrors, ThrowOnError>({
        url: "/api/companies",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Incarca o dovada (poza sau PDF) pentru o activitate
 */
export const uploadCollabPhoto = <ThrowOnError extends boolean = false>(
    options: Options<UploadCollabPhotoData, ThrowOnError>,
) => {
    return (options.client ?? client).post<UploadCollabPhotoResponses, UploadCollabPhotoErrors, ThrowOnError>({
        ...formDataBodySerializer,
        url: "/api/collab/{token}/files",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });
};

/**
 * Depune o activitate practica sau un exercitiu cu clasa in numele scolii
 */
export const submitCollabActivity = <ThrowOnError extends boolean = false>(
    options: Options<SubmitCollabActivityData, ThrowOnError>,
) => {
    return (options.client ?? client).post<SubmitCollabActivityResponses, SubmitCollabActivityErrors, ThrowOnError>({
        url: "/api/collab/{token}/activities",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Confirma scoala si editia pentru un cod
 */
export const confirmaCodScoala = <ThrowOnError extends boolean = false>(
    options: Options<ConfirmaCodScoalaData, ThrowOnError>,
) => {
    return (options.client ?? client).post<ConfirmaCodScoalaResponses, ConfirmaCodScoalaErrors, ThrowOnError>({
        url: "/api/collab/cod",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Emite un link de colaborator pentru codul dat
 */
export const deschideSesiuneCodScoala = <ThrowOnError extends boolean = false>(
    options: Options<DeschideSesiuneCodScoalaData, ThrowOnError>,
) => {
    return (options.client ?? client).post<
        DeschideSesiuneCodScoalaResponses,
        DeschideSesiuneCodScoalaErrors,
        ThrowOnError
    >({
        url: "/api/collab/cod/sesiune",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const register = <ThrowOnError extends boolean = false>(options: Options<RegisterData, ThrowOnError>) => {
    return (options.client ?? client).post<RegisterResponses, RegisterErrors, ThrowOnError>({
        url: "/api/auth/register",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const refreshToken = <ThrowOnError extends boolean = false>(
    options: Options<RefreshTokenData, ThrowOnError>,
) => {
    return (options.client ?? client).post<RefreshTokenResponses, RefreshTokenErrors, ThrowOnError>({
        url: "/api/auth/refresh-token",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const reenroll = <ThrowOnError extends boolean = false>(options: Options<ReenrollData, ThrowOnError>) => {
    return (options.client ?? client).post<ReenrollResponses, ReenrollErrors, ThrowOnError>({
        url: "/api/auth/reenroll",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const verify = <ThrowOnError extends boolean = false>(options: Options<VerifyData, ThrowOnError>) => {
    return (options.client ?? client).post<VerifyResponses, VerifyErrors, ThrowOnError>({
        responseType: "json",
        url: "/api/auth/otp/verify",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const request = <ThrowOnError extends boolean = false>(options: Options<RequestData, ThrowOnError>) => {
    return (options.client ?? client).post<RequestResponses, RequestErrors, ThrowOnError>({
        url: "/api/auth/otp/request",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Inscriere: exista un cont pe email? Daca da (non-ELEV), trimite codul de intrare
 */
export const otpInscriere = <ThrowOnError extends boolean = false>(
    options: Options<OtpInscriereData, ThrowOnError>,
) => {
    return (options.client ?? client).post<OtpInscriereResponses, OtpInscriereErrors, ThrowOnError>({
        responseType: "json",
        url: "/api/auth/otp/inscriere",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Inscriere de profesor prin cod, fara parola
 */
export const otpInregistrare = <ThrowOnError extends boolean = false>(
    options: Options<OtpInregistrareData, ThrowOnError>,
) => {
    return (options.client ?? client).post<OtpInregistrareResponses, OtpInregistrareErrors, ThrowOnError>({
        responseType: "json",
        url: "/api/auth/otp/inregistrare",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const logout = <ThrowOnError extends boolean = false>(options: Options<LogoutData, ThrowOnError>) => {
    return (options.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
        url: "/api/auth/logout",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const forgotPassword = <ThrowOnError extends boolean = false>(
    options: Options<ForgotPasswordData, ThrowOnError>,
) => {
    return (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
        url: "/api/auth/forgot-password",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const exchange = <ThrowOnError extends boolean = false>(options: Options<ExchangeData, ThrowOnError>) => {
    return (options.client ?? client).post<ExchangeResponses, ExchangeErrors, ThrowOnError>({
        url: "/api/auth/exchange",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const authenticate = <ThrowOnError extends boolean = false>(
    options: Options<AuthenticateData, ThrowOnError>,
) => {
    return (options.client ?? client).post<AuthenticateResponses, AuthenticateErrors, ThrowOnError>({
        url: "/api/auth/authenticate",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Get all answers
 */
export const getAllAnswers = <ThrowOnError extends boolean = false>(
    options?: Options<GetAllAnswersData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetAllAnswersResponses, GetAllAnswersErrors, ThrowOnError>({
        responseTransformer: getAllAnswersResponseTransformer,
        url: "/api/answers",
        ...options,
    });
};

/**
 * Update an existing answer
 */
export const updateAnswer = <ThrowOnError extends boolean = false>(
    options: Options<UpdateAnswerData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateAnswerResponses, UpdateAnswerErrors, ThrowOnError>({
        responseTransformer: updateAnswerResponseTransformer,
        url: "/api/answers",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Create a new answer
 */
export const createAnswer = <ThrowOnError extends boolean = false>(
    options: Options<CreateAnswerData, ThrowOnError>,
) => {
    return (options.client ?? client).post<CreateAnswerResponses, CreateAnswerErrors, ThrowOnError>({
        responseTransformer: createAnswerResponseTransformer,
        responseType: "json",
        url: "/api/answers",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Adminul corecteaza cantitatea, contactul sau adresa, doar cat cererea e NOUA
 */
export const editWasteContainerRequest = <ThrowOnError extends boolean = false>(
    options: Options<EditWasteContainerRequestData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        EditWasteContainerRequestResponses,
        EditWasteContainerRequestErrors,
        ThrowOnError
    >({
        responseTransformer: editWasteContainerRequestResponseTransformer,
        responseType: "json",
        url: "/api/waste-container-requests/{id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Adminul confirma solicitarea (NOUA -> PROCESATA); profesorul primeste mesaj
 */
export const markWasteContainerRequestProcessed = <ThrowOnError extends boolean = false>(
    options: Options<MarkWasteContainerRequestProcessedData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        MarkWasteContainerRequestProcessedResponses,
        MarkWasteContainerRequestProcessedErrors,
        ThrowOnError
    >({
        responseTransformer: markWasteContainerRequestProcessedResponseTransformer,
        responseType: "json",
        url: "/api/waste-container-requests/{id}/procesata",
        ...options,
    });
};

/**
 * Marcheaza solicitarea livrata (PROCESATA -> LIVRATA); profesorul primeste mesaj
 */
export const markWasteContainerRequestDelivered = <ThrowOnError extends boolean = false>(
    options: Options<MarkWasteContainerRequestDeliveredData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        MarkWasteContainerRequestDeliveredResponses,
        MarkWasteContainerRequestDeliveredErrors,
        ThrowOnError
    >({
        responseTransformer: markWasteContainerRequestDeliveredResponseTransformer,
        responseType: "json",
        url: "/api/waste-container-requests/{id}/livrata",
        ...options,
    });
};

/**
 * Update actual waste values (DEEE, DBA, Becuri si Neorane)
 */
export const updateWasteCollectionFormRealValues = <ThrowOnError extends boolean = false>(
    options: Options<UpdateWasteCollectionFormRealValuesData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        UpdateWasteCollectionFormRealValuesResponses,
        UpdateWasteCollectionFormRealValuesErrors,
        ThrowOnError
    >({
        responseTransformer: updateWasteCollectionFormRealValuesResponseTransformer,
        url: "/api/waste-collection-forms/{id}/waste-real-values",
        ...options,
    });
};

/**
 * Validate or reject waste collection form
 */
export const validateWasteCollectionForm = <ThrowOnError extends boolean = false>(
    options: Options<ValidateWasteCollectionFormData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        ValidateWasteCollectionFormResponses,
        ValidateWasteCollectionFormErrors,
        ThrowOnError
    >({
        responseTransformer: validateWasteCollectionFormResponseTransformer,
        url: "/api/waste-collection-forms/{id}/validation",
        ...options,
    });
};

/**
 * Mark waste collection form as processed or unprocessed
 */
export const processWasteCollectionForm = <ThrowOnError extends boolean = false>(
    options: Options<ProcessWasteCollectionFormData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        ProcessWasteCollectionFormResponses,
        ProcessWasteCollectionFormErrors,
        ThrowOnError
    >({
        responseTransformer: processWasteCollectionFormResponseTransformer,
        url: "/api/waste-collection-forms/{id}/process",
        ...options,
    });
};

/**
 * Admin update of waste collection form
 */
export const updateWasteCollectionFormByAdmin = <ThrowOnError extends boolean = false>(
    options: Options<UpdateWasteCollectionFormByAdminData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        UpdateWasteCollectionFormByAdminResponses,
        UpdateWasteCollectionFormByAdminErrors,
        ThrowOnError
    >({
        responseTransformer: updateWasteCollectionFormByAdminResponseTransformer,
        url: "/api/waste-collection-forms/admin-update",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const setPhoneCallNote = <ThrowOnError extends boolean = false>(
    options: Options<SetPhoneCallNoteData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<SetPhoneCallNoteResponses, SetPhoneCallNoteErrors, ThrowOnError>({
        url: "/api/users/{id}/phone-call-note",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const activateUser = <ThrowOnError extends boolean = false>(
    options: Options<ActivateUserData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<ActivateUserResponses, ActivateUserErrors, ThrowOnError>({
        responseTransformer: activateUserResponseTransformer,
        url: "/api/users/{id}/activation",
        ...options,
    });
};

export const updateUserActivation = <ThrowOnError extends boolean = false>(
    options: Options<UpdateUserActivationData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateUserActivationResponses, UpdateUserActivationErrors, ThrowOnError>({
        responseTransformer: updateUserActivationResponseTransformer,
        url: "/api/users/update-activation",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const updateUserSignature = <ThrowOnError extends boolean = false>(
    options: Options<UpdateUserSignatureData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateUserSignatureResponses, UpdateUserSignatureErrors, ThrowOnError>({
        responseTransformer: updateUserSignatureResponseTransformer,
        url: "/api/users/signature",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Get user profile
 *
 * Retrieve user profile. If userId and/or editionId parameters are provided, requires ADMIN or DBEST role. If no parameters provided, returns current user's profile. If userId is provided without editionId, uses target user's current edition. If both are provided, returns profile for that user in that edition.
 */
export const getUserProfile = <ThrowOnError extends boolean = false>(
    options?: Options<GetUserProfileData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetUserProfileResponses, GetUserProfileErrors, ThrowOnError>({
        responseTransformer: getUserProfileResponseTransformer,
        url: "/api/users/profile",
        ...options,
    });
};

export const updateUserProfile = <ThrowOnError extends boolean = false>(
    options: Options<UpdateUserProfileData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateUserProfileResponses, UpdateUserProfileErrors, ThrowOnError>({
        responseTransformer: updateUserProfileResponseTransformer,
        url: "/api/users/profile",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const updateUserByAdmin = <ThrowOnError extends boolean = false>(
    options: Options<UpdateUserByAdminData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateUserByAdminResponses, UpdateUserByAdminErrors, ThrowOnError>({
        responseTransformer: updateUserByAdminResponseTransformer,
        url: "/api/users/admin-update",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Confirma / marcheaza trimis / anuleaza (admin); coordonatorul primeste mesaj la fiecare pas
 */
export const updateTicketRedemptionStatus = <ThrowOnError extends boolean = false>(
    options: Options<UpdateTicketRedemptionStatusData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        UpdateTicketRedemptionStatusResponses,
        UpdateTicketRedemptionStatusErrors,
        ThrowOnError
    >({
        responseTransformer: updateTicketRedemptionStatusResponseTransformer,
        url: "/api/ticket-redemptions/{id}/status",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Reassign school request to a different professor
 */
export const reassignSchoolRequestToProfessor = <ThrowOnError extends boolean = false>(
    options: Options<ReassignSchoolRequestToProfessorData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        ReassignSchoolRequestToProfessorResponses,
        ReassignSchoolRequestToProfessorErrors,
        ThrowOnError
    >({
        responseTransformer: reassignSchoolRequestToProfessorResponseTransformer,
        url: "/api/school-requests/reassign-professor",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Mark the onboarding video as watched on the current professor's request
 *
 * Idempotent: keeps the first timestamp. 404 if the professor has no request in the current edition, 409 if that request was already decided.
 */
export const markOwnSchoolRequestVideoSeen = <ThrowOnError extends boolean = false>(
    options?: Options<MarkOwnSchoolRequestVideoSeenData, ThrowOnError>,
) => {
    return (options?.client ?? client).patch<
        MarkOwnSchoolRequestVideoSeenResponses,
        MarkOwnSchoolRequestVideoSeenErrors,
        ThrowOnError
    >({
        responseTransformer: markOwnSchoolRequestVideoSeenResponseTransformer,
        url: "/api/school-requests/own/video",
        ...options,
    });
};

/**
 * Update approval status of school request
 */
export const updateSchoolRequestApprovalStatus = <ThrowOnError extends boolean = false>(
    options: Options<UpdateSchoolRequestApprovalStatusData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        UpdateSchoolRequestApprovalStatusResponses,
        UpdateSchoolRequestApprovalStatusErrors,
        ThrowOnError
    >({
        responseTransformer: updateSchoolRequestApprovalStatusResponseTransformer,
        url: "/api/school-requests/approval-status",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Admin update of school request
 */
export const updateSchoolRequestByAdmin = <ThrowOnError extends boolean = false>(
    options: Options<UpdateSchoolRequestByAdminData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        UpdateSchoolRequestByAdminResponses,
        UpdateSchoolRequestByAdminErrors,
        ThrowOnError
    >({
        responseTransformer: updateSchoolRequestByAdminResponseTransformer,
        url: "/api/school-requests/admin-update",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Mark notification as read or unread
 */
export const markNotificationAsRead = <ThrowOnError extends boolean = false>(
    options: Options<MarkNotificationAsReadData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<
        MarkNotificationAsReadResponses,
        MarkNotificationAsReadErrors,
        ThrowOnError
    >({
        url: "/api/notifications/{id}/read",
        ...options,
    });
};

/**
 * Hide or unhide lesson
 */
export const hideLesson = <ThrowOnError extends boolean = false>(options: Options<HideLessonData, ThrowOnError>) => {
    return (options.client ?? client).patch<HideLessonResponses, HideLessonErrors, ThrowOnError>({
        url: "/api/lessons/{id}/hide",
        ...options,
    });
};

/**
 * Update participants count for CLASS_EXERCISE
 *
 * Allows professor to update number of participants for CLASS_EXERCISE lesson before approval. Professors can only update their own school's submissions. ADMIN/DBEST can update any school.
 */
export const updateParticipants = <ThrowOnError extends boolean = false>(
    options: Options<UpdateParticipantsData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<UpdateParticipantsResponses, UpdateParticipantsErrors, ThrowOnError>({
        responseTransformer: updateParticipantsResponseTransformer,
        url: "/api/lessons/answers/{id}/participants",
        ...options,
    });
};

/**
 * Approve or reject lesson answer
 *
 * Approve or reject a student's lesson submission. For CLASS_EXERCISE, when approving, send EITHER `fise` (validated worksheets; points = 8 x fise) OR `points` (literal points). Both together, a negative `fise`, or `fise` on another lesson type -> 400.
 */
export const confirmLesson = <ThrowOnError extends boolean = false>(
    options: Options<ConfirmLessonData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<ConfirmLessonResponses, ConfirmLessonErrors, ThrowOnError>({
        responseTransformer: confirmLessonResponseTransformer,
        url: "/api/lessons/answers/{id}/approval",
        ...options,
    });
};

export const resetPassword = <ThrowOnError extends boolean = false>(
    options: Options<ResetPasswordData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
        url: "/api/auth/reset-password",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

export const changePassword = <ThrowOnError extends boolean = false>(
    options: Options<ChangePasswordData, ThrowOnError>,
) => {
    return (options.client ?? client).patch<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
        url: "/api/auth/change-password",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};

/**
 * Solicitarile unei editii, filtrate si paginate, pentru echipa de logistica
 */
export const getWasteContainerRequestsReport = <ThrowOnError extends boolean = false>(
    options: Options<GetWasteContainerRequestsReportData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        GetWasteContainerRequestsReportResponses,
        GetWasteContainerRequestsReportErrors,
        ThrowOnError
    >({
        responseTransformer: getWasteContainerRequestsReportResponseTransformer,
        url: "/api/waste-container-requests/report",
        ...options,
    });
};

/**
 * Cifrele de pe chip-uri: pe stare, pe fel si total, inainte de filtrele ecranului
 */
export const getWasteContainerRequestsReportCounters = <ThrowOnError extends boolean = false>(
    options?: Options<GetWasteContainerRequestsReportCountersData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        GetWasteContainerRequestsReportCountersResponses,
        GetWasteContainerRequestsReportCountersErrors,
        ThrowOnError
    >({
        responseTransformer: getWasteContainerRequestsReportCountersResponseTransformer,
        url: "/api/waste-container-requests/report/contoare",
        ...options,
    });
};

/**
 * Solicitarile scolii profesorului, pe editia curenta
 */
export const getOwnWasteContainerRequests = <ThrowOnError extends boolean = false>(
    options?: Options<GetOwnWasteContainerRequestsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        GetOwnWasteContainerRequestsResponses,
        GetOwnWasteContainerRequestsErrors,
        ThrowOnError
    >({
        responseTransformer: getOwnWasteContainerRequestsResponseTransformer,
        url: "/api/waste-container-requests/own",
        ...options,
    });
};

/**
 * Delete waste collection form by ID
 */
export const deleteWasteCollectionForm = <ThrowOnError extends boolean = false>(
    options: Options<DeleteWasteCollectionFormData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<
        DeleteWasteCollectionFormResponses,
        DeleteWasteCollectionFormErrors,
        ThrowOnError
    >({
        url: "/api/waste-collection-forms/{id}",
        ...options,
    });
};

/**
 * Get waste collection form by ID
 */
export const getWasteCollectionFormById = <ThrowOnError extends boolean = false>(
    options: Options<GetWasteCollectionFormByIdData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        GetWasteCollectionFormByIdResponses,
        GetWasteCollectionFormByIdErrors,
        ThrowOnError
    >({
        responseTransformer: getWasteCollectionFormByIdResponseTransformer,
        url: "/api/waste-collection-forms/{id}",
        ...options,
    });
};

/**
 * Get waste collection forms report
 *
 * Retrieve paginated list of waste collection forms with filtering and sorting
 */
export const getWasteCollectionFormsReport = <ThrowOnError extends boolean = false>(
    options: Options<GetWasteCollectionFormsReportData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        GetWasteCollectionFormsReportResponses,
        GetWasteCollectionFormsReportErrors,
        ThrowOnError
    >({
        responseTransformer: getWasteCollectionFormsReportResponseTransformer,
        url: "/api/waste-collection-forms/report",
        ...options,
    });
};

/**
 * Get default waste collection form
 */
export const getDefaultWasteCollectionForm = <ThrowOnError extends boolean = false>(
    options?: Options<GetDefaultWasteCollectionFormData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        GetDefaultWasteCollectionFormResponses,
        GetDefaultWasteCollectionFormErrors,
        ThrowOnError
    >({
        responseTransformer: getDefaultWasteCollectionFormResponseTransformer,
        url: "/api/waste-collection-forms/default",
        ...options,
    });
};

/**
 * Get professors with school requests report
 *
 * Retrieve paginated report of professors and their school registration requests including school details and addresses
 */
export const getUsersWithSchoolRequestsReport = <ThrowOnError extends boolean = false>(
    options: Options<GetUsersWithSchoolRequestsReportData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        GetUsersWithSchoolRequestsReportResponses,
        GetUsersWithSchoolRequestsReportErrors,
        ThrowOnError
    >({
        responseTransformer: getUsersWithSchoolRequestsReportResponseTransformer,
        url: "/api/users/school-requests/report",
        ...options,
    });
};

export const getSchoolClasses = <ThrowOnError extends boolean = false>(
    options?: Options<GetSchoolClassesData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetSchoolClassesResponses, GetSchoolClassesErrors, ThrowOnError>({
        url: "/api/users/school-classes-dropdown",
        ...options,
    });
};

/**
 * Get users report
 *
 * Retrieve paginated list of users with filtering and sorting by user attributes
 */
export const getUsersReport = <ThrowOnError extends boolean = false>(
    options: Options<GetUsersReportData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetUsersReportResponses, GetUsersReportErrors, ThrowOnError>({
        responseTransformer: getUsersReportResponseTransformer,
        url: "/api/users/report",
        ...options,
    });
};

export const getContacts = <ThrowOnError extends boolean = false>(options?: Options<GetContactsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetContactsResponses, GetContactsErrors, ThrowOnError>({
        url: "/api/users/contacts",
        ...options,
    });
};

/**
 * Istoricul scolii coordonatorului pe editia curenta
 */
export const getOwnTicketRedemptions = <ThrowOnError extends boolean = false>(
    options?: Options<GetOwnTicketRedemptionsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        GetOwnTicketRedemptionsResponses,
        GetOwnTicketRedemptionsErrors,
        ThrowOnError
    >({
        responseTransformer: getOwnTicketRedemptionsResponseTransformer,
        url: "/api/ticket-redemptions/own",
        ...options,
    });
};

/**
 * Top elevi dupa total puncte lectii (editia curenta implicit)
 *
 * Paginat si ordonat (loc = dense rank pe total). Export Excel: GET /api/files/excel-reports?url=/api/students/leaderboard
 */
export const getStudentLeaderboard = <ThrowOnError extends boolean = false>(
    options: Options<GetStudentLeaderboardData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetStudentLeaderboardResponses, GetStudentLeaderboardErrors, ThrowOnError>({
        responseTransformer: getStudentLeaderboardResponseTransformer,
        url: "/api/students/leaderboard",
        ...options,
    });
};

/**
 * Delete slide by ID
 */
export const deleteSlide = <ThrowOnError extends boolean = false>(options: Options<DeleteSlideData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteSlideResponses, DeleteSlideErrors, ThrowOnError>({
        url: "/api/slides/{id}",
        ...options,
    });
};

/**
 * Get slide by ID
 */
export const getSlideById = <ThrowOnError extends boolean = false>(
    options: Options<GetSlideByIdData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetSlideByIdResponses, GetSlideByIdErrors, ThrowOnError>({
        url: "/api/slides/{id}",
        ...options,
    });
};

/**
 * Get default slide
 */
export const getDefaultSlide = <ThrowOnError extends boolean = false>(
    options?: Options<GetDefaultSlideData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetDefaultSlideResponses, GetDefaultSlideErrors, ThrowOnError>({
        url: "/api/slides/default",
        ...options,
    });
};

/**
 * Sablonul precompletat al unei scoli (administrare)
 */
export const downloadProtocolDeColaborare = <ThrowOnError extends boolean = false>(
    options: Options<DownloadProtocolDeColaborareData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        DownloadProtocolDeColaborareResponses,
        DownloadProtocolDeColaborareErrors,
        ThrowOnError
    >({
        url: "/api/schools/{schoolId}/protocol-de-colaborare",
        ...options,
    });
};

/**
 * Delete school by ID
 */
export const deleteSchool = <ThrowOnError extends boolean = false>(
    options: Options<DeleteSchoolData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<DeleteSchoolResponses, DeleteSchoolErrors, ThrowOnError>({
        url: "/api/schools/{id}",
        ...options,
    });
};

/**
 * Get school by ID
 */
export const getSchoolById = <ThrowOnError extends boolean = false>(
    options: Options<GetSchoolByIdData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetSchoolByIdResponses, GetSchoolByIdErrors, ThrowOnError>({
        responseTransformer: getSchoolByIdResponseTransformer,
        url: "/api/schools/{id}",
        ...options,
    });
};

/**
 * Soldul unei scoli (admin, sau profesorul ei)
 */
export const getSchoolPointsBalance = <ThrowOnError extends boolean = false>(
    options: Options<GetSchoolPointsBalanceData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetSchoolPointsBalanceResponses, GetSchoolPointsBalanceErrors, ThrowOnError>({
        url: "/api/schools/{id}/points-balance",
        ...options,
    });
};

/**
 * Get edition schools status report
 *
 * Comprehensive report of schools per edition including waste collection, lesson statistics, and performance metrics. Complex aggregation query.
 */
export const getSchoolsStatusReport = <ThrowOnError extends boolean = false>(
    options: Options<GetSchoolsStatusReportData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetSchoolsStatusReportResponses, GetSchoolsStatusReportErrors, ThrowOnError>({
        responseTransformer: getSchoolsStatusReportResponseTransformer,
        url: "/api/schools/status-report",
        ...options,
    });
};

/**
 * Get schools report
 *
 * Retrieve paginated list of schools with optional filtering and sorting. Parameters are sent as individual query parameters.
 */
export const getSchoolsReport = <ThrowOnError extends boolean = false>(
    options: Options<GetSchoolsReportData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetSchoolsReportResponses, GetSchoolsReportErrors, ThrowOnError>({
        responseTransformer: getSchoolsReportResponseTransformer,
        url: "/api/schools/report",
        ...options,
    });
};

/**
 * Get a school's registration status for the current edition
 *
 * Pre-check for the school registration form: tells the professor whether the school is already registered this edition, has a pending request, or was only present in past editions (possible takeover). Returns the current professor's NAME only - never the email.
 */
export const getSchoolRegistrationStatus = <ThrowOnError extends boolean = false>(
    options: Options<GetSchoolRegistrationStatusData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        GetSchoolRegistrationStatusResponses,
        GetSchoolRegistrationStatusErrors,
        ThrowOnError
    >({
        url: "/api/schools/registration-status",
        ...options,
    });
};

/**
 * Get current user's school
 */
export const getOwnSchool = <ThrowOnError extends boolean = false>(
    options?: Options<GetOwnSchoolData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetOwnSchoolResponses, GetOwnSchoolErrors, ThrowOnError>({
        responseTransformer: getOwnSchoolResponseTransformer,
        url: "/api/schools/own",
        ...options,
    });
};

/**
 * Profesorul isi descarca sablonul precompletat al scolii lui
 */
export const downloadOwnProtocolDeColaborare = <ThrowOnError extends boolean = false>(
    options?: Options<DownloadOwnProtocolDeColaborareData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        DownloadOwnProtocolDeColaborareResponses,
        DownloadOwnProtocolDeColaborareErrors,
        ThrowOnError
    >({
        url: "/api/schools/own/protocol-de-colaborare",
        ...options,
    });
};

/**
 * Soldul scolii coordonatorului curent
 */
export const getOwnSchoolPointsBalance = <ThrowOnError extends boolean = false>(
    options?: Options<GetOwnSchoolPointsBalanceData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        GetOwnSchoolPointsBalanceResponses,
        GetOwnSchoolPointsBalanceErrors,
        ThrowOnError
    >({
        url: "/api/schools/own/points-balance",
        ...options,
    });
};

/**
 * Get paginated list of schools for import
 */
export const getSchoolsImportData = <ThrowOnError extends boolean = false>(
    options: Options<GetSchoolsImportDataData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetSchoolsImportDataResponses, GetSchoolsImportDataErrors, ThrowOnError>({
        responseTransformer: getSchoolsImportDataResponseTransformer,
        url: "/api/schools/import-data",
        ...options,
    });
};

/**
 * Get dropdown list of schools
 */
export const getSchoolsDropdown = <ThrowOnError extends boolean = false>(
    options?: Options<GetSchoolsDropdownData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetSchoolsDropdownResponses, GetSchoolsDropdownErrors, ThrowOnError>({
        url: "/api/schools/dropdown",
        ...options,
    });
};

/**
 * Get default school
 */
export const getDefaultSchool = <ThrowOnError extends boolean = false>(
    options?: Options<GetDefaultSchoolData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetDefaultSchoolResponses, GetDefaultSchoolErrors, ThrowOnError>({
        responseTransformer: getDefaultSchoolResponseTransformer,
        url: "/api/schools/default",
        ...options,
    });
};

/**
 * Get list of all counties
 */
export const getCountiesList = <ThrowOnError extends boolean = false>(
    options?: Options<GetCountiesListData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetCountiesListResponses, GetCountiesListErrors, ThrowOnError>({
        url: "/api/schools/counties",
        ...options,
    });
};

/**
 * Delete school request by ID
 */
export const deleteSchoolRequest = <ThrowOnError extends boolean = false>(
    options: Options<DeleteSchoolRequestData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<DeleteSchoolRequestResponses, DeleteSchoolRequestErrors, ThrowOnError>({
        url: "/api/school-requests/{id}",
        ...options,
    });
};

/**
 * Get school request by ID
 */
export const getSchoolRequestById = <ThrowOnError extends boolean = false>(
    options: Options<GetSchoolRequestByIdData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetSchoolRequestByIdResponses, GetSchoolRequestByIdErrors, ThrowOnError>({
        responseTransformer: getSchoolRequestByIdResponseTransformer,
        url: "/api/school-requests/{id}",
        ...options,
    });
};

/**
 * Get school request by user ID
 */
export const getSchoolRequestByUserId = <ThrowOnError extends boolean = false>(
    options: Options<GetSchoolRequestByUserIdData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        GetSchoolRequestByUserIdResponses,
        GetSchoolRequestByUserIdErrors,
        ThrowOnError
    >({
        responseTransformer: getSchoolRequestByUserIdResponseTransformer,
        url: "/api/school-requests/user/{id}",
        ...options,
    });
};

/**
 * Get school requests report
 *
 * Retrieve paginated list of school registration requests with filtering
 */
export const getSchoolRequestsReport = <ThrowOnError extends boolean = false>(
    options: Options<GetSchoolRequestsReportData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        GetSchoolRequestsReportResponses,
        GetSchoolRequestsReportErrors,
        ThrowOnError
    >({
        responseTransformer: getSchoolRequestsReportResponseTransformer,
        url: "/api/school-requests/report",
        ...options,
    });
};

/**
 * Get current user's school request
 */
export const getOwnSchoolRequest = <ThrowOnError extends boolean = false>(
    options?: Options<GetOwnSchoolRequestData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetOwnSchoolRequestResponses, GetOwnSchoolRequestErrors, ThrowOnError>({
        responseType: "json",
        url: "/api/school-requests/own",
        ...options,
    });
};

/**
 * Istoricul profesorilor unei scoli
 *
 * Jurnalul schimbarilor de profesor plus intrari derivate din cererile aprobate (sursa DIN_CERERI), in ordine cronologica. Doar DBEST/ADMIN.
 */
export const getIstoricProfesori = <ThrowOnError extends boolean = false>(
    options?: Options<GetIstoricProfesoriData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetIstoricProfesoriResponses, GetIstoricProfesoriErrors, ThrowOnError>({
        responseTransformer: getIstoricProfesoriResponseTransformer,
        url: "/api/school-requests/istoric-profesori",
        ...options,
    });
};

/**
 * Get default school request
 */
export const getDefaultSchoolRequest = <ThrowOnError extends boolean = false>(
    options?: Options<GetDefaultSchoolRequestData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        GetDefaultSchoolRequestResponses,
        GetDefaultSchoolRequestErrors,
        ThrowOnError
    >({
        responseTransformer: getDefaultSchoolRequestResponseTransformer,
        url: "/api/school-requests/default",
        ...options,
    });
};

/**
 * Get scheduler run history
 */
export const getSchedulerRuns = <ThrowOnError extends boolean = false>(
    options: Options<GetSchedulerRunsData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetSchedulerRunsResponses, GetSchedulerRunsErrors, ThrowOnError>({
        responseTransformer: getSchedulerRunsResponseTransformer,
        url: "/api/scheduler-runs",
        ...options,
    });
};

/**
 * Get parental approval details for a specific user
 *
 * Retrieves full parental approval form details including signature and all consent fields. Requires ADMIN or PROFESOR role.
 */
export const getParentalApprovalByUser = <ThrowOnError extends boolean = false>(
    options: Options<GetParentalApprovalByUserData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        GetParentalApprovalByUserResponses,
        GetParentalApprovalByUserErrors,
        ThrowOnError
    >({
        responseTransformer: getParentalApprovalByUserResponseTransformer,
        url: "/api/parental-approvals/users/{userId}",
        ...options,
    });
};

/**
 * Delete option by ID
 */
export const deleteOption = <ThrowOnError extends boolean = false>(
    options: Options<DeleteOptionData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<DeleteOptionResponses, DeleteOptionErrors, ThrowOnError>({
        url: "/api/options/{id}",
        ...options,
    });
};

/**
 * Get option by ID
 */
export const getOptionById = <ThrowOnError extends boolean = false>(
    options: Options<GetOptionByIdData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetOptionByIdResponses, GetOptionByIdErrors, ThrowOnError>({
        url: "/api/options/{id}",
        ...options,
    });
};

/**
 * Get default option
 */
export const getDefaultOption = <ThrowOnError extends boolean = false>(
    options?: Options<GetDefaultOptionData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetDefaultOptionResponses, GetDefaultOptionErrors, ThrowOnError>({
        url: "/api/options/default",
        ...options,
    });
};

/**
 * Delete notification by ID
 */
export const deleteNotification = <ThrowOnError extends boolean = false>(
    options: Options<DeleteNotificationData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<DeleteNotificationResponses, DeleteNotificationErrors, ThrowOnError>({
        url: "/api/notifications/{id}",
        ...options,
    });
};

/**
 * Get notification by ID
 */
export const getNotificationById = <ThrowOnError extends boolean = false>(
    options: Options<GetNotificationByIdData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetNotificationByIdResponses, GetNotificationByIdErrors, ThrowOnError>({
        responseTransformer: getNotificationByIdResponseTransformer,
        url: "/api/notifications/{id}",
        ...options,
    });
};

/**
 * Get notification receiver status
 */
export const getNotificationReceiversStatus = <ThrowOnError extends boolean = false>(
    options: Options<GetNotificationReceiversStatusData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        GetNotificationReceiversStatusResponses,
        GetNotificationReceiversStatusErrors,
        ThrowOnError
    >({
        responseTransformer: getNotificationReceiversStatusResponseTransformer,
        url: "/api/notifications/{id}/receivers",
        ...options,
    });
};

/**
 * Get notifications report
 *
 * Retrieve paginated list of notifications with filtering and sorting
 */
export const getNotificationsReport = <ThrowOnError extends boolean = false>(
    options: Options<GetNotificationsReportData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetNotificationsReportResponses, GetNotificationsReportErrors, ThrowOnError>({
        responseTransformer: getNotificationsReportResponseTransformer,
        url: "/api/notifications/report",
        ...options,
    });
};

/**
 * Get outbox notifications (DEPRECATED - use /report endpoint instead)
 *
 * @deprecated
 */
export const getOutboxNotificationsDeprecated = <ThrowOnError extends boolean = false>(
    options: Options<GetOutboxNotificationsDeprecatedData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        GetOutboxNotificationsDeprecatedResponses,
        GetOutboxNotificationsDeprecatedErrors,
        ThrowOnError
    >({
        responseTransformer: getOutboxNotificationsDeprecatedResponseTransformer,
        url: "/api/notifications/outbox",
        ...options,
    });
};

/**
 * Get own inbox notifications
 *
 * Paginated INAPP notifications where the authenticated user is the receiver. Scoped server-side to the caller; ordering is fixed (unread first, newest first).
 */
export const getInboxNotifications = <ThrowOnError extends boolean = false>(
    options: Options<GetInboxNotificationsData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetInboxNotificationsResponses, GetInboxNotificationsErrors, ThrowOnError>({
        responseTransformer: getInboxNotificationsResponseTransformer,
        url: "/api/notifications/inbox",
        ...options,
    });
};

/**
 * Get default notification
 */
export const getDefaultNotification = <ThrowOnError extends boolean = false>(
    options?: Options<GetDefaultNotificationData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetDefaultNotificationResponses, GetDefaultNotificationErrors, ThrowOnError>(
        {
            responseTransformer: getDefaultNotificationResponseTransformer,
            url: "/api/notifications/default",
            ...options,
        },
    );
};

/**
 * Delete lesson by ID
 */
export const deleteLesson = <ThrowOnError extends boolean = false>(
    options: Options<DeleteLessonData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<DeleteLessonResponses, DeleteLessonErrors, ThrowOnError>({
        url: "/api/lessons/{id}",
        ...options,
    });
};

/**
 * Get lesson by ID
 */
export const getLessonById = <ThrowOnError extends boolean = false>(
    options: Options<GetLessonByIdData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetLessonByIdResponses, GetLessonByIdErrors, ThrowOnError>({
        responseTransformer: getLessonByIdResponseTransformer,
        url: "/api/lessons/{id}",
        ...options,
    });
};

/**
 * Descarca PDF-ul cu raspunsurile fisei (PROFESOR/ADMIN/DBEST)
 */
export const descarcaRaspunsuriPdf = <ThrowOnError extends boolean = false>(
    options: Options<DescarcaRaspunsuriPdfData, ThrowOnError>,
) => {
    return (options.client ?? client).get<DescarcaRaspunsuriPdfResponses, DescarcaRaspunsuriPdfErrors, ThrowOnError>({
        responseType: "blob",
        url: "/api/lessons/{id}/raspunsuri-pdf",
        ...options,
    });
};

/**
 * Descarca PDF-ul de exercitii al activitatii, ca atasament
 */
export const descarcaExercitiiPdf = <ThrowOnError extends boolean = false>(
    options: Options<DescarcaExercitiiPdfData, ThrowOnError>,
) => {
    return (options.client ?? client).get<DescarcaExercitiiPdfResponses, DescarcaExercitiiPdfErrors, ThrowOnError>({
        responseType: "blob",
        url: "/api/lessons/{id}/exercitii-pdf",
        ...options,
    });
};

/**
 * Get lessons by type
 */
export const getLessonsByType = <ThrowOnError extends boolean = false>(
    options: Options<GetLessonsByTypeData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetLessonsByTypeResponses, GetLessonsByTypeErrors, ThrowOnError>({
        responseTransformer: getLessonsByTypeResponseTransformer,
        url: "/api/lessons/types",
        ...options,
    });
};

/**
 * Get default lesson
 */
export const getDefaultLesson = <ThrowOnError extends boolean = false>(
    options?: Options<GetDefaultLessonData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetDefaultLessonResponses, GetDefaultLessonErrors, ThrowOnError>({
        responseTransformer: getDefaultLessonResponseTransformer,
        url: "/api/lessons/default",
        ...options,
    });
};

export const getLessonProgressByType = <ThrowOnError extends boolean = false>(
    options?: Options<GetLessonProgressByTypeData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        GetLessonProgressByTypeResponses,
        GetLessonProgressByTypeErrors,
        ThrowOnError
    >({
        responseTransformer: getLessonProgressByTypeResponseTransformer,
        url: "/api/lessons/answers",
        ...options,
    });
};

/**
 * Raspunsurile unei submisii (un singur attempt)
 */
export const getAnswersForSubmission = <ThrowOnError extends boolean = false>(
    options: Options<GetAnswersForSubmissionData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        GetAnswersForSubmissionResponses,
        GetAnswersForSubmissionErrors,
        ThrowOnError
    >({
        responseTransformer: getAnswersForSubmissionResponseTransformer,
        url: "/api/lessons/answers/{id}/answers",
        ...options,
    });
};

/**
 * Get lesson answers report
 *
 * Retrieve paginated list of lesson answers with filtering and sorting. Supports filtering by lesson, user, school, approval status, and timestamps.
 */
export const getLessonAnswersReport = <ThrowOnError extends boolean = false>(
    options: Options<GetLessonAnswersReportData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetLessonAnswersReportResponses, GetLessonAnswersReportErrors, ThrowOnError>({
        responseTransformer: getLessonAnswersReportResponseTransformer,
        url: "/api/lessons/answers/report",
        ...options,
    });
};

export const getAllFolders = <ThrowOnError extends boolean = false>(
    options?: Options<GetAllFoldersData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetAllFoldersResponses, GetAllFoldersErrors, ThrowOnError>({
        url: "/api/files/folders",
        ...options,
    });
};

export const exportReport = <ThrowOnError extends boolean = false>(
    options: Options<ExportReportData, ThrowOnError>,
) => {
    return (options.client ?? client).get<ExportReportResponses, ExportReportErrors, ThrowOnError>({
        url: "/api/files/excel-reports",
        ...options,
    });
};

/**
 * Delete a FAQ entry
 */
export const deleteFaqEntry = <ThrowOnError extends boolean = false>(
    options: Options<DeleteFaqEntryData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<DeleteFaqEntryResponses, DeleteFaqEntryErrors, ThrowOnError>({
        url: "/api/faq/{id}",
        ...options,
    });
};

export const getById = <ThrowOnError extends boolean = false>(options: Options<GetByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetByIdResponses, GetByIdErrors, ThrowOnError>({
        url: "/api/faq/{id}",
        ...options,
    });
};

export const getDefault = <ThrowOnError extends boolean = false>(options?: Options<GetDefaultData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDefaultResponses, GetDefaultErrors, ThrowOnError>({
        url: "/api/faq/default",
        ...options,
    });
};

/**
 * Delete edition by ID
 */
export const deleteEdition = <ThrowOnError extends boolean = false>(
    options: Options<DeleteEditionData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<DeleteEditionResponses, DeleteEditionErrors, ThrowOnError>({
        url: "/api/editions/{id}",
        ...options,
    });
};

/**
 * Get edition by ID
 */
export const getEditionById = <ThrowOnError extends boolean = false>(
    options: Options<GetEditionByIdData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetEditionByIdResponses, GetEditionByIdErrors, ThrowOnError>({
        responseTransformer: getEditionByIdResponseTransformer,
        url: "/api/editions/{id}",
        ...options,
    });
};

/**
 * Get default edition
 */
export const getDefaultEdition = <ThrowOnError extends boolean = false>(
    options?: Options<GetDefaultEditionData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetDefaultEditionResponses, GetDefaultEditionErrors, ThrowOnError>({
        responseTransformer: getDefaultEditionResponseTransformer,
        url: "/api/editions/default",
        ...options,
    });
};

/**
 * Video links shown during the school registration flow
 *
 * Configured through application properties until the edition documents become admin-managed (SP-07). PROFESOR, DBEST and ADMIN.
 */
export const getOnboardingVideo = <ThrowOnError extends boolean = false>(
    options?: Options<GetOnboardingVideoData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetOnboardingVideoResponses, GetOnboardingVideoErrors, ThrowOnError>({
        url: "/api/editions/current/onboarding-video",
        ...options,
    });
};

/**
 * Public document links for the current edition
 *
 * Protocol, regulament, mecanism and colaboratori. Configured through application properties until the edition documents become admin-managed (SP-07). Public: the same links are shown on screens without login.
 */
export const getEditionDocuments = <ThrowOnError extends boolean = false>(
    options?: Options<GetEditionDocumentsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetEditionDocumentsResponses, GetEditionDocumentsErrors, ThrowOnError>({
        url: "/api/editions/current/documents",
        ...options,
    });
};

/**
 * Delete company by ID
 */
export const deleteCompany = <ThrowOnError extends boolean = false>(
    options: Options<DeleteCompanyData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<DeleteCompanyResponses, DeleteCompanyErrors, ThrowOnError>({
        url: "/api/companies/{id}",
        ...options,
    });
};

/**
 * Get company by ID
 */
export const getCompanyById = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanyByIdData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetCompanyByIdResponses, GetCompanyByIdErrors, ThrowOnError>({
        url: "/api/companies/{id}",
        ...options,
    });
};

/**
 * Get default company
 */
export const getDefaultCompany = <ThrowOnError extends boolean = false>(
    options?: Options<GetDefaultCompanyData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetDefaultCompanyResponses, GetDefaultCompanyErrors, ThrowOnError>({
        url: "/api/companies/default",
        ...options,
    });
};

/**
 * Scoala, editia si activitatile disponibile pentru un link
 */
export const getCollabInfo = <ThrowOnError extends boolean = false>(
    options: Options<GetCollabInfoData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetCollabInfoResponses, GetCollabInfoErrors, ThrowOnError>({
        responseTransformer: getCollabInfoResponseTransformer,
        url: "/api/collab/{token}",
        ...options,
    });
};

/**
 * Detaliile unei activitati disponibile prin link
 */
export const getCollabActivity = <ThrowOnError extends boolean = false>(
    options: Options<GetCollabActivityData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetCollabActivityResponses, GetCollabActivityErrors, ThrowOnError>({
        responseTransformer: getCollabActivityResponseTransformer,
        url: "/api/collab/{token}/activities/{lessonId}",
        ...options,
    });
};

/**
 * Descarca raspunsurile fisei, prin link
 */
export const descarcaRaspunsuriPdfColab = <ThrowOnError extends boolean = false>(
    options: Options<DescarcaRaspunsuriPdfColabData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        DescarcaRaspunsuriPdfColabResponses,
        DescarcaRaspunsuriPdfColabErrors,
        ThrowOnError
    >({
        responseType: "blob",
        url: "/api/collab/{token}/activities/{lessonId}/raspunsuri-pdf",
        ...options,
    });
};

/**
 * Descarca fisa de exercitii a activitatii, prin link
 */
export const descarcaExercitiiPdfColab = <ThrowOnError extends boolean = false>(
    options: Options<DescarcaExercitiiPdfColabData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        DescarcaExercitiiPdfColabResponses,
        DescarcaExercitiiPdfColabErrors,
        ThrowOnError
    >({
        responseType: "blob",
        url: "/api/collab/{token}/activities/{lessonId}/exercitii-pdf",
        ...options,
    });
};

/**
 * Delete answer by ID
 */
export const deleteAnswer = <ThrowOnError extends boolean = false>(
    options: Options<DeleteAnswerData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<DeleteAnswerResponses, DeleteAnswerErrors, ThrowOnError>({
        url: "/api/answers/{id}",
        ...options,
    });
};

/**
 * Get answer by ID
 */
export const getAnswerById = <ThrowOnError extends boolean = false>(
    options: Options<GetAnswerByIdData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetAnswerByIdResponses, GetAnswerByIdErrors, ThrowOnError>({
        responseTransformer: getAnswerByIdResponseTransformer,
        url: "/api/answers/{id}",
        ...options,
    });
};

/**
 * Get answers for current user's lesson
 */
export const getAnswersByLesson = <ThrowOnError extends boolean = false>(
    options: Options<GetAnswersByLessonData, ThrowOnError>,
) => {
    return (options.client ?? client).get<GetAnswersByLessonResponses, GetAnswersByLessonErrors, ThrowOnError>({
        responseTransformer: getAnswersByLessonResponseTransformer,
        url: "/api/answers/lessons/{lessonId}",
        ...options,
    });
};

/**
 * Get student answers by lesson and user (professors only)
 *
 * Allows professors to view individual student slide answers for review. Used for HOMEWORK photo review and lesson approval workflow.
 */
export const getStudentAnswersByLessonAndUser = <ThrowOnError extends boolean = false>(
    options: Options<GetStudentAnswersByLessonAndUserData, ThrowOnError>,
) => {
    return (options.client ?? client).get<
        GetStudentAnswersByLessonAndUserResponses,
        GetStudentAnswersByLessonAndUserErrors,
        ThrowOnError
    >({
        responseTransformer: getStudentAnswersByLessonAndUserResponseTransformer,
        url: "/api/answers/lessons/{lessonId}/students/{userId}",
        ...options,
    });
};

/**
 * Get default answer
 */
export const getDefaultAnswer = <ThrowOnError extends boolean = false>(
    options?: Options<GetDefaultAnswerData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<GetDefaultAnswerResponses, GetDefaultAnswerErrors, ThrowOnError>({
        responseTransformer: getDefaultAnswerResponseTransformer,
        url: "/api/answers/default",
        ...options,
    });
};

/**
 * Analyze Azure Blob Storage for orphaned files
 */
export const analyzeBlobStorage = <ThrowOnError extends boolean = false>(
    options?: Options<AnalyzeBlobStorageData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<AnalyzeBlobStorageResponses, AnalyzeBlobStorageErrors, ThrowOnError>({
        responseTransformer: analyzeBlobStorageResponseTransformer,
        url: "/api/admin/blob-analysis",
        ...options,
    });
};

/**
 * Health check
 *
 * Returns 200 OK to verify API is running
 */
export const root = <ThrowOnError extends boolean = false>(options?: Options<RootData, ThrowOnError>) => {
    return (options?.client ?? client).get<RootResponses, RootErrors, ThrowOnError>({
        url: "/",
        ...options,
    });
};

/**
 * Sterge un nivel (400 daca are rascumparari)
 */
export const deleteTicketTier = <ThrowOnError extends boolean = false>(
    options: Options<DeleteTicketTierData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<DeleteTicketTierResponses, DeleteTicketTierErrors, ThrowOnError>({
        url: "/api/ticket-tiers/{id}",
        ...options,
    });
};

/**
 * Revoca un link (idempotent)
 */
export const revokeCollaboratorLink = <ThrowOnError extends boolean = false>(
    options: Options<RevokeCollaboratorLinkData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<
        RevokeCollaboratorLinkResponses,
        RevokeCollaboratorLinkErrors,
        ThrowOnError
    >({
        url: "/api/schools/{schoolId}/collaborator-links/{linkId}",
        ...options,
    });
};

/**
 * Delete lesson answers for specific user, lesson, and edition
 *
 * Allows ADMIN/DBEST to delete all lesson answers (including the LessonAnswer aggregate and all related Answer records) for a specific student in a specific edition. Used to reset stuck attempts (orphaned answer deadlock) or remove invalid submissions. Uses multi-step batch deletion to avoid FK constraint violations.
 */
export const deleteLessonAnswersByUserLessonAndEdition = <ThrowOnError extends boolean = false>(
    options: Options<DeleteLessonAnswersByUserLessonAndEditionData, ThrowOnError>,
) => {
    return (options.client ?? client).delete<
        DeleteLessonAnswersByUserLessonAndEditionResponses,
        DeleteLessonAnswersByUserLessonAndEditionErrors,
        ThrowOnError
    >({
        url: "/api/lessons/answers/users/{userId}/lessons/{lessonId}/editions/{editionId}",
        ...options,
    });
};

/**
 * Delete file from Azure Blob Storage
 *
 * Allows ADMIN/DBEST to delete files by filename. Restricted to administrators to prevent accidental data loss.
 */
export const deleteFile = <ThrowOnError extends boolean = false>(options: Options<DeleteFileData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteFileResponses, DeleteFileErrors, ThrowOnError>({
        url: "/api/files",
        ...options,
    });
};
